var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.0757 8.09522L14.762 12.7818L12.7815 14.7619L8.09512 10.0758L3.40925 14.7619L1.42871 12.7818L6.11458 8.09522L1.42871 3.40867L3.40925 1.42856L8.09512 6.11461L12.7815 1.42856L14.762 3.40867L10.0757 8.09522Z",
  fill: "#001246"
})));
export default SvgIconClose;